export function checkboxToArr(arr, name, checked){
    if (checked === false) {
      const index = arr.indexOf(name);
      arr.splice(index, 1);
    } else {
      arr.push(name);
    }
    return arr;
}